// convert flat folder array to a { folder, subfolders }[] array based on parentId attr
export var covertToFoldersWithSubfolders = function (folders) {
    return (folders
        // attach subfolders
        .map(function (folder) { return ({
        folder: folder,
        subfolders: folders.filter(function (potentialSubfolder) {
            return potentialSubfolder.parentId === folder.folderId;
        }) || [],
    }); })
        // leave only top level folders
        .filter(function (_a) {
        var folder = _a.folder;
        return isTopLevelFolder(folder);
    }));
};
export var isTopLevelFolder = function (folder) { return !folder.parentId; };
export var filterTopLevelFolders = function (folders) {
    return folders.filter(isTopLevelFolder);
};
//# sourceMappingURL=folders.js.map